import { useState } from 'react';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');
  :root { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --d:#222222; --line:#EDE9E2; }

  .mf { font-family: 'Inter', sans-serif; color: var(--d); }
  .mf-progress { height: 3px; background: var(--line); border-radius: 2px; margin-bottom: 32px; overflow: hidden; }
  .mf-progress-fill { height: 100%; background: linear-gradient(90deg, var(--g), var(--o)); border-radius: 2px; transition: width .4s ease; }

  /* FORMATION */
  .mf-formation { max-width: 720px; margin: 0 auto; }
  .mf-part { margin-bottom: 44px; }
  .mf-eyebrow { display: inline-flex; align-items: center; gap: 8px; font-size: 10.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--o); margin-bottom: 14px; }
  .mf-eyebrow::before { content: ''; width: 18px; height: 2px; background: var(--o); display: inline-block; }
  .mf-part h2 { font-family: 'Playfair Display', serif; font-size: clamp(20px, 2.5vw, 26px); color: var(--g); font-weight: 700; line-height: 1.2; margin-bottom: 14px; }
  .mf-part p { font-size: 15px; color: #555; line-height: 1.75; margin-bottom: 14px; font-weight: 300; }
  .mf-part strong { color: var(--d); font-weight: 600; }

  .mf-hl { background: rgba(23,59,52,0.07); border-left: 3px solid var(--g); border-radius: 0 12px 12px 0; padding: 16px 20px; margin: 16px 0; font-size: 14.5px; color: #333; line-height: 1.65; }
  .mf-hl.orange { background: rgba(228,87,46,0.07); border-left-color: var(--o); }

  .mf-stat { background: var(--g); border-radius: 16px; padding: 22px 28px; margin: 18px 0; display: flex; align-items: center; gap: 20px; }
  .mf-stat-num { font-family: 'Playfair Display', serif; font-size: 48px; font-weight: 700; color: var(--o); line-height: 1; flex-shrink: 0; }
  .mf-stat-text strong { display: block; font-size: 15px; color: #fff; margin-bottom: 4px; }
  .mf-stat-text span { font-size: 13.5px; color: rgba(246,242,236,0.55); line-height: 1.6; }

  .mf-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin: 16px 0; }
  .mf-gi { background: #fff; border: 1px solid var(--line); border-radius: 12px; padding: 16px 18px; }
  .mf-gi-ico { font-size: 20px; margin-bottom: 8px; }
  .mf-gi-title { font-size: 13.5px; font-weight: 700; color: var(--g); margin-bottom: 5px; }
  .mf-gi-desc { font-size: 12.5px; color: #777; line-height: 1.55; }

  .mf-parcours { display: flex; flex-direction: column; gap: 0; margin: 16px 0; }
  .mf-step { display: flex; gap: 14px; padding: 14px 16px; background: #fff; border: 1px solid var(--line); }
  .mf-step:first-child { border-radius: 12px 12px 0 0; }
  .mf-step:last-child { border-radius: 0 0 12px 12px; }
  .mf-step:not(:last-child) { border-bottom: none; }
  .mf-step-day { font-size: 10.5px; font-weight: 700; color: var(--o); width: 38px; flex-shrink: 0; text-align: center; padding-top: 2px; letter-spacing: .04em; }
  .mf-step strong { display: block; font-size: 13.5px; color: var(--d); margin-bottom: 3px; }
  .mf-step span { font-size: 12.5px; color: #777; line-height: 1.55; }

  .mf-outils { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; margin: 16px 0; }
  .mf-outil { background: #fff; border: 1px solid var(--line); border-radius: 12px; padding: 14px; text-align: center; }
  .mf-outil-ico { font-size: 22px; margin-bottom: 7px; }
  .mf-outil-name { font-size: 13px; font-weight: 700; color: var(--g); margin-bottom: 4px; }
  .mf-outil-desc { font-size: 11.5px; color: #888; line-height: 1.5; }
  .mf-outil-prix { font-size: 11px; font-weight: 700; color: var(--o); margin-top: 6px; }

  /* DIAGNOSTIC */
  .mf-diagnostic { max-width: 640px; margin: 0 auto; }
  .mf-diag-title { font-family: 'Playfair Display', serif; font-size: 22px; color: var(--g); font-weight: 700; margin-bottom: 6px; }
  .mf-diag-sub { font-size: 14px; color: #777; margin-bottom: 28px; line-height: 1.6; }
  .mf-question { background: #fff; border: 1px solid var(--line); border-radius: 14px; padding: 22px 24px; margin-bottom: 14px; }
  .mf-question-text { font-size: 15px; font-weight: 600; color: var(--d); margin-bottom: 14px; line-height: 1.45; }
  .mf-options { display: flex; flex-direction: column; gap: 8px; }
  .mf-option { padding: 11px 16px; border: 1.5px solid var(--line); border-radius: 10px; cursor: pointer; font-size: 14px; color: #444; transition: all .15s; background: #FDFCFA; text-align: left; font-family: 'Inter', sans-serif; }
  .mf-option:hover { border-color: var(--g); background: rgba(23,59,52,0.05); color: var(--g); }
  .mf-option.selected { border-color: var(--g); background: rgba(23,59,52,0.08); color: var(--g); font-weight: 600; }

  /* RÉSULTAT DIAGNOSTIC */
  .mf-result { background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 4px 6px rgba(23,59,52,0.04), 0 20px 40px rgba(23,59,52,0.10); margin-bottom: 24px; }
  .mf-result-header { background: var(--g); padding: 24px 28px; position: relative; overflow: hidden; }
  .mf-result-header::before { content: ''; position: absolute; top: -60px; right: -60px; width: 180px; height: 180px; border-radius: 50%; background: rgba(228,87,46,0.1); pointer-events: none; }
  .mf-result-badge { display: inline-flex; align-items: center; gap: 6px; background: rgba(228,87,46,0.2); border: 1px solid rgba(228,87,46,0.35); color: var(--o); font-size: 10px; font-weight: 700; padding: 4px 12px; border-radius: 999px; letter-spacing: .1em; margin-bottom: 10px; position: relative; z-index: 2; }
  .mf-result-title { font-family: 'Playfair Display', serif; font-size: 20px; color: #fff; font-weight: 700; margin-bottom: 4px; position: relative; z-index: 2; }
  .mf-result-sub { font-size: 12px; color: rgba(246,242,236,0.45); letter-spacing: .06em; text-transform: uppercase; position: relative; z-index: 2; }
  .mf-result-body { padding: 24px 28px; }
  .mf-result-block { background: #FDFCFA; border: 1px solid var(--line); border-radius: 14px; overflow: hidden; margin-bottom: 14px; }
  .mf-result-block-head { background: var(--c); padding: 10px 16px; border-bottom: 1px solid var(--line); font-size: 10px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; color: #AAA09A; display: flex; align-items: center; gap: 7px; }
  .mf-result-block-body { padding: 14px 16px; font-size: 14px; color: #333; line-height: 1.7; }
  .mf-dot-list { display: flex; flex-direction: column; gap: 7px; }
  .mf-dot-item { display: flex; align-items: flex-start; gap: 9px; font-size: 13.5px; color: #444; line-height: 1.55; }
  .mf-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--o); flex-shrink: 0; margin-top: 5px; }

  /* CTA */
  .mf-cta {
    background: linear-gradient(135deg, var(--g) 0%, #0E2820 100%);
    border-radius: 24px; padding: 40px 36px;
    position: relative; overflow: hidden;
    box-shadow: 0 20px 48px rgba(23,59,52,0.25);
  }
  .mf-cta::before { content: ''; position: absolute; top: -80px; right: -80px; width: 280px; height: 280px; border-radius: 50%; background: rgba(228,87,46,0.12); pointer-events: none; }
  .mf-cta-eyebrow { font-size: 10.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--o); margin-bottom: 14px; display: flex; align-items: center; gap: 8px; position: relative; z-index: 2; }
  .mf-cta-eyebrow::before { content: ''; width: 20px; height: 2px; background: var(--o); }
  .mf-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(22px, 3vw, 30px); color: #fff; font-weight: 700; line-height: 1.2; margin-bottom: 14px; position: relative; z-index: 2; }
  .mf-cta h2 em { font-style: italic; color: var(--o); }
  .mf-cta-desc { font-size: 15px; color: rgba(246,242,236,0.6); line-height: 1.75; margin-bottom: 28px; max-width: 520px; position: relative; z-index: 2; font-weight: 300; }

  .mf-cta-audit {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12);
    border-radius: 16px; padding: 22px 24px; margin-bottom: 28px; position: relative; z-index: 2;
  }
  .mf-cta-audit-title { font-family: 'Playfair Display', serif; font-size: 17px; font-weight: 700; color: #fff; margin-bottom: 10px; }
  .mf-cta-audit-items { display: flex; flex-direction: column; gap: 9px; }
  .mf-cta-audit-item { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; color: rgba(246,242,236,0.8); line-height: 1.55; }
  .mf-cta-audit-check { width: 20px; height: 20px; border-radius: 50%; background: rgba(228,87,46,0.2); border: 1px solid rgba(228,87,46,0.4); display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }

  .mf-cta-btns { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; position: relative; z-index: 2; }
  .mf-cta-btn { background: var(--o); color: #fff; border: none; border-radius: 999px; padding: 15px 30px; font-size: 15px; font-weight: 700; cursor: pointer; font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 9px; box-shadow: 0 6px 20px rgba(228,87,46,0.4); transition: all .15s; text-decoration: none; }
  .mf-cta-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 28px rgba(228,87,46,0.5); }
  .mf-cta-note { font-size: 12px; color: rgba(246,242,236,0.3); margin-top: 14px; position: relative; z-index: 2; }

  /* BTNS NAV */
  .mf-nav { display: flex; justify-content: space-between; align-items: center; margin-top: 32px; gap: 12px; }
  .mf-btn-primary { background: var(--g); color: #F6F2EC; border: none; border-radius: 999px; padding: 13px 28px; font-size: 14.5px; font-weight: 700; cursor: pointer; font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 14px rgba(23,59,52,0.25); transition: all .15s; }
  .mf-btn-primary:hover { background: #0E2820; transform: translateY(-1px); }
  .mf-btn-secondary { background: transparent; color: var(--g); border: 1.5px solid var(--line); border-radius: 999px; padding: 12px 24px; font-size: 14px; font-weight: 600; cursor: pointer; font-family: 'Inter', sans-serif; }
  .mf-btn-secondary:hover { border-color: var(--g); }

  @media(max-width:640px) {
    .mf-grid, .mf-outils { grid-template-columns: 1fr; }
    .mf-stat { flex-direction: column; text-align: center; }
    .mf-cta { padding: 28px 20px; }
    .mf-cta-btns { flex-direction: column; }
    .mf-cta-btn { width: 100%; justify-content: center; }
  }
`;

// ─── QUESTIONS DIAGNOSTIC ────────────────────────────────────
const QUESTIONS_DIAGNOSTIC = [
  {
    q: "Quel est ton type d'activité ?",
    key: 'activite',
    options: [
      { val: 'commerce', label: '🏪 Commerce physique (boutique, salon, restaurant, artisan...)' },
      { val: 'service', label: '🤝 Prestation de service (coach, consultant, thérapeute, formateur...)' },
      { val: 'ecommerce', label: '🛒 E-commerce ou vente en ligne' },
      { val: 'hybride', label: '🔄 Hybride (physique + en ligne)' },
    ]
  },
  {
    q: "Combien de clients actifs as-tu en ce moment ?",
    key: 'nbClients',
    options: [
      { val: 'moins10', label: '🌱 Moins de 10, je démarre' },
      { val: '10a50', label: '📈 Entre 10 et 50 clients' },
      { val: '50a200', label: '🚀 Entre 50 et 200 clients' },
      { val: 'plus200', label: '⭐ Plus de 200 clients' },
    ]
  },
  {
    q: "Comment gardes-tu contact avec tes clients après un achat ?",
    key: 'contact',
    options: [
      { val: 'rien', label: '😬 Je ne fais rien de particulier' },
      { val: 'reseau', label: '📱 Je poste sur les réseaux, ils me suivent s\'ils veulent' },
      { val: 'email', label: '📧 J\'envoie parfois des emails' },
      { val: 'systeme', label: '✅ J\'ai un système en place (newsletter, SMS, programme de fidélité)' },
    ]
  },
  {
    q: "Quel est ton objectif principal avec la fidélisation ?",
    key: 'objectif',
    options: [
      { val: 'revente', label: '🔁 Générer des achats répétés' },
      { val: 'recommandation', label: '🗣️ Obtenir des recommandations et avis' },
      { val: 'valeur', label: '💰 Augmenter le panier moyen de mes clients existants' },
      { val: 'tout', label: '🎯 Les trois à la fois' },
    ]
  },
];

// ─── RECOMMANDATIONS PAR PROFIL ──────────────────────────────
function getRecommendation(answers) {
  const { activite, nbClients, contact, objectif } = answers;

  const profils = {
    commerce: {
      titre: 'Commerce physique',
      systeme: 'Carte de fidélité digitale + SMS marketing',
      outils: ['Une carte fidélité digitale accessible par QR code', 'Un outil de SMS marketing pour les relances', 'Un email automatique post-achat'],
      actions: [
        'Mettre en place une carte de fidélité digitale accessible par QR code',
        'Collecter l\'email/téléphone à chaque passage en caisse',
        'Envoyer un SMS de remerciement 24h après l\'achat',
        'Créer une offre anniversaire automatique pour tes clients',
        'Lancer un programme "parrainage" avec une récompense concrète',
      ],
      urgence: contact === 'rien' ? 'Critique' : contact === 'reseau' ? 'Élevée' : 'Modérée',
      potentiel: 'Un client fidèle dépense en moyenne 67% de plus qu\'un nouveau client.',
    },
    service: {
      titre: 'Prestataire de service',
      systeme: 'Newsletter de valeur + suivi post-accompagnement',
      outils: ['Une newsletter pour rester en contact régulier', 'Un outil de suivi client simple', 'Une séquence email automatisée post-prestation'],
      actions: [
        'Envoyer un email de suivi 7 jours après la fin d\'une prestation',
        'Créer une newsletter mensuelle avec du contenu à valeur ajoutée',
        'Proposer une offre de renouvellement à J+90',
        'Demander un témoignage à J+30 lorsque les résultats sont visibles',
        'Créer un programme "VIP" pour tes clients récurrents',
      ],
      urgence: contact === 'rien' ? 'Critique' : 'Élevée',
      potentiel: 'Un client satisfait génère en moyenne 3 recommandations. As-tu un système pour les activer ?',
    },
    ecommerce: {
      titre: 'E-commerce',
      systeme: 'Séquences email automatisées + programme de points',
      outils: ["Un outil d'email automation pour les séquences post-achat", 'Un programme de points avec paliers de récompenses', 'La relance automatique de panier abandonné'],
      actions: [
        'Automatiser une séquence email post-achat (J+1, J+7, J+30)',
        'Mettre en place la relance de panier abandonné (récupère 10-15% des paniers)',
        'Créer un programme de points avec paliers de récompenses',
        'Segmenter tes clients par fréquence d\'achat et personnaliser les offres',
        'Lancer une vente privée réservée aux clients existants',
      ],
      urgence: 'Élevée',
      potentiel: 'La relance de panier abandonné seule peut générer +12% de CA sans nouveau client.',
    },
    hybride: {
      titre: 'Activité hybride',
      systeme: 'CRM unifié + omnicanal (email + SMS + réseau)',
      outils: ['Un CRM centralisé pour gérer tous tes contacts', 'Une carte fidélité digitale valable partout', 'Une combinaison email + SMS selon le canal préféré du client'],
      actions: [
        'Centraliser tous tes contacts dans un seul outil (online + offline)',
        'Créer un programme de fidélité valable en boutique ET en ligne',
        'Automatiser les relances selon le canal d\'achat préféré du client',
        'Mettre en place un système de recommandation cross-canal',
        'Synchroniser tes données clients pour une vue 360°',
      ],
      urgence: 'Élevée',
      potentiel: 'Les clients omnicanaux dépensent 250% de plus que les clients mono-canal.',
    },
  };

  return profils[activite] || profils['service'];
}

// ─── FORMATION ───────────────────────────────────────────────
const FORMATION = [
  {
    num: 'Partie 1',
    titre: "Fidéliser coûte 5x moins cher qu'acquérir, et rapporte bien plus",
    content: () => (
      <>
        <p>La plupart des indépendants passent 80% de leur énergie à chercher de nouveaux clients. C'est compréhensible au démarrage. Mais c'est une erreur stratégique dès que tu as une base de clients existants.</p>
        <div className="mf-stat">
          <div className="mf-stat-num">5x</div>
          <div className="mf-stat-text">
            <strong>Acquérir un nouveau client coûte 5 fois plus cher</strong>
            <span>que de vendre à un client existant. Et la probabilité de vendre à un client actuel est de 60 à 70%, contre 5 à 20% pour un prospect froid.</span>
          </div>
        </div>
        <p>Tes clients actuels te connaissent, te font confiance, et ont déjà prouvé qu'ils étaient prêts à payer. <strong>Ils sont ton actif le plus précieux, et le plus souvent ignoré.</strong></p>
        <div className="mf-hl orange">
          Un client qui revient une deuxième fois a 54% de chances de revenir une troisième. La fidélisation crée un effet boule de neige que l'acquisition seule ne peut pas générer.
        </div>
      </>
    )
  },
  {
    num: 'Partie 2',
    titre: "Ce que veulent vraiment tes clients après un achat",
    content: () => (
      <>
        <p>Après un achat, ton client passe par plusieurs états émotionnels. Si tu n'interviens pas, il passe à autre chose, et oublie simplement de revenir.</p>
        <div className="mf-parcours">
          {[
            ['J+0', 'L\'euphorie', 'Il vient d\'acheter, il est satisfait. C\'est le moment idéal pour le remercier et renforcer sa décision.'],
            ['J+7', 'L\'évaluation', 'Il a utilisé ton produit ou service. Il a une opinion. C\'est le moment de lui demander son retour.'],
            ['J+30', 'L\'oubli', 'Sans contact de ta part, tu disparais de son radar. Il ne cherche pas activement à revenir.'],
            ['J+90', 'L\'opportunité', 'Si tu reprends contact avec une offre pertinente, il est réceptif. Sinon, tu l\'as potentiellement perdu.'],
            ['J+180', 'La décision', 'Soit il est devenu un client fidèle, soit il est allé voir un concurrent. C\'est souvent là que tout se joue.'],
          ].map(([jour, titre, desc], i) => (
            <div key={i} className="mf-step">
              <div className="mf-step-day">{jour}</div>
              <div><strong>{titre}</strong><span>{desc}</span></div>
            </div>
          ))}
        </div>
        <div className="mf-hl">La fidélisation, c'est simplement rester présent aux bons moments. Un système simple suffit pour multiplier tes revenus récurrents.</div>
      </>
    )
  },
  {
    num: 'Partie 3',
    titre: "Les outils digitaux qui font le travail à ta place",
    content: () => (
      <>
        <p>La bonne nouvelle : on n'est plus en 2010. Les outils de fidélisation ont été démocratisés, des solutions existent pour tous les budgets, y compris le budget zéro au démarrage.</p>
        <div className="mf-outils">
          {[
            { ico:'📧', name:'Email marketing', desc:'Le canal le plus rentable. 1€ investi = 42€ en retour en moyenne.', prix:'Accessible dès le démarrage' },
            { ico:'📱', name:'SMS marketing', desc:'Taux d\'ouverture de 98%. Lu en moins de 3 minutes.', prix:'~0,07€ par SMS' },
            { ico:'🎟️', name:'Carte fidélité digitale', desc:'QR code, points, récompenses. Zéro papier, zéro perte.', prix:'Gratuit à 29€/mois' },
            { ico:'🤖', name:'Automation email', desc:'Séquences automatiques déclenchées par les actions du client.', prix:'Souvent inclus dans les outils email' },
            { ico:'💬', name:'WhatsApp Business', desc:'Idéal pour les services locaux. Taux d\'ouverture > 90%.', prix:'Gratuit' },
            { ico:'⭐', name:'Programme de points', desc:'Gamification de la fidélité. Crée de l\'attachement à la marque.', prix:'À partir de 0€' },
          ].map((o,i) => (
            <div key={i} className="mf-outil">
              <div className="mf-outil-ico">{o.ico}</div>
              <div className="mf-outil-name">{o.name}</div>
              <div className="mf-outil-desc">{o.desc}</div>
              <div className="mf-outil-prix">{o.prix}</div>
            </div>
          ))}
        </div>
      </>
    )
  },
  {
    num: 'Partie 4',
    titre: "Le système minimal qui change tout",
    content: () => (
      <>
        <p>Pas besoin d'un CRM complexe ou d'une équipe marketing. Un système de fidélisation efficace peut tenir en <strong>4 actions automatisées</strong> que tu configures une fois.</p>
        <div className="mf-grid">
          {[
            { ico:'🙏', t:'Remerciement J+1', d:'Un email ou SMS automatique qui remercie le client et lui confirme qu\'il a fait le bon choix.' },
            { ico:'💬', t:'Avis J+7', d:'Une demande d\'avis quand l\'expérience est fraîche. 70% des clients laissent un avis si on le demande au bon moment.' },
            { ico:'🎁', t:'Offre de fidélité J+30', d:'Une remise, un bonus ou un accès exclusif réservé aux clients existants.' },
            { ico:'📞', t:'Relance J+90', d:'Un message personnalisé pour proposer la prochaine étape ou un nouveau service.' },
          ].map((e,i) => (
            <div key={i} className="mf-gi">
              <div className="mf-gi-ico">{e.ico}</div>
              <div className="mf-gi-title">{e.t}</div>
              <div className="mf-gi-desc">{e.d}</div>
            </div>
          ))}
        </div>
        <div className="mf-hl orange">
          Ce système se configure en une demi-journée. Une fois en place, il travaille pour toi 24h/24 sans intervention. C'est ça, la vraie levier de croissance d'un indépendant.
        </div>
      </>
    )
  },
  {
    num: 'Partie 5',
    titre: "Ton diagnostic personnalisé",
    content: () => (
      <p>
        Maintenant que tu comprends les enjeux, répondons à 4 questions sur ton activité. En 2 minutes, tu obtiens une recommandation personnalisée sur le système de fidélisation le plus adapté à ta situation.
      </p>
    )
  },
];

// ─── COMPOSANT PRINCIPAL ──────────────────────────────────────
export function ModuleFidelisation({ onValidate }) {
  const [phase, setPhase] = useState('formation');
  const [formationStep, setFormationStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [diagStep, setDiagStep] = useState(0);
  const [recommendation, setRecommendation] = useState(null);

  const progress = phase === 'formation'
    ? ((formationStep + 1) / (FORMATION.length + 2)) * 100
    : phase === 'diagnostic'
    ? ((FORMATION.length + 1 + diagStep / QUESTIONS_DIAGNOSTIC.length) / (FORMATION.length + 2)) * 100
    : 100;

  const handleAnswer = (key, val) => {
    const newAnswers = { ...answers, [key]: val };
    setAnswers(newAnswers);
    if (diagStep < QUESTIONS_DIAGNOSTIC.length - 1) {
      setTimeout(() => setDiagStep(s => s + 1), 300);
    } else {
      setTimeout(() => {
        setRecommendation(getRecommendation(newAnswers));
        setPhase('result');
      }, 300);
    }
  };

  const ArrowIcon = () => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <div className="mf">
      <style>{CSS}</style>

      <div className="mf-progress">
        <div className="mf-progress-fill" style={{width:`${progress}%`}}></div>
      </div>

      {/* ── FORMATION ── */}
      {phase === 'formation' && (
        <div className="mf-formation">
          {FORMATION.map((part, idx) => (
            idx <= formationStep && (
              <div key={idx} className="mf-part">
                <div className="mf-eyebrow">{part.num}</div>
                <h2>{part.titre}</h2>
                {part.content()}
              </div>
            )
          ))}
          <div className="mf-nav">
            {formationStep > 0
              ? <button className="mf-btn-secondary" onClick={() => setFormationStep(s => s-1)}>← Précédent</button>
              : <div/>
            }
            {formationStep < FORMATION.length - 1 ? (
              <button className="mf-btn-primary" onClick={() => setFormationStep(s => s+1)}>
                Partie suivante <ArrowIcon/>
              </button>
            ) : (
              <button className="mf-btn-primary" onClick={() => setPhase('diagnostic')}>
                Lancer mon diagnostic <ArrowIcon/>
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── DIAGNOSTIC ── */}
      {phase === 'diagnostic' && (
        <div className="mf-diagnostic">
          <div className="mf-diag-title">Ton diagnostic personnalisé</div>
          <div className="mf-diag-sub">
            {diagStep + 1} question sur {QUESTIONS_DIAGNOSTIC.length}, réponds instinctivement.
          </div>

          {QUESTIONS_DIAGNOSTIC.map((q, qi) => (
            qi === diagStep && (
              <div key={qi} className="mf-question">
                <div className="mf-question-text">{q.q}</div>
                <div className="mf-options">
                  {q.options.map((opt, oi) => (
                    <button
                      key={oi}
                      className={`mf-option ${answers[q.key] === opt.val ? 'selected' : ''}`}
                      onClick={() => handleAnswer(q.key, opt.val)}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            )
          ))}
        </div>
      )}

      {/* ── RÉSULTAT + CTA ── */}
      {phase === 'result' && recommendation && (
        <div>
          {/* Fiche résultat */}
          <div className="mf-result">
            <div className="mf-result-header">
              <div className="mf-result-badge">DIAGNOSTIC FIDÉLISATION</div>
              <div className="mf-result-title">Recommandations pour : {recommendation.titre}</div>
              <div className="mf-result-sub">
                Urgence : {recommendation.urgence} · {recommendation.systeme}
              </div>
            </div>
            <div className="mf-result-body">
              <div className="mf-result-block">
                <div className="mf-result-block-head">💡 Système recommandé</div>
                <div className="mf-result-block-body">{recommendation.systeme}</div>
              </div>
              <div className="mf-result-block">
                <div className="mf-result-block-head">🛠️ Outils adaptés à ton activité</div>
                <div className="mf-result-block-body">
                  <div className="mf-dot-list">
                    {recommendation.outils.map((o,i) => (
                      <div key={i} className="mf-dot-item"><div className="mf-dot"></div>{o}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mf-result-block">
                <div className="mf-result-block-head">🚀 5 actions prioritaires</div>
                <div className="mf-result-block-body">
                  <div className="mf-dot-list">
                    {recommendation.actions.map((a,i) => (
                      <div key={i} className="mf-dot-item"><div className="mf-dot"></div>{a}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{background:'rgba(228,87,46,0.07)',border:'1px solid rgba(228,87,46,0.2)',borderRadius:12,padding:'14px 16px'}}>
                <div style={{fontSize:10,fontWeight:700,letterSpacing:'.1em',textTransform:'uppercase',color:'var(--o)',marginBottom:7}}>Le chiffre qui compte</div>
                <div style={{fontSize:14,color:'#444',lineHeight:1.65}}>{recommendation.potentiel}</div>
              </div>
            </div>
          </div>

          {/* CTA Stratvente */}
          <div className="mf-cta">
            <div className="mf-cta-eyebrow">Passe à l'action avec Stratvente</div>
            <h2>Ton système de fidélisation,<br/><em>mis en place pour toi.</em></h2>
            <p className="mf-cta-desc">
              Tu connais maintenant les enjeux et les outils. L'étape qui fait la différence, c'est la mise en place. Configurer les séquences, choisir les bons outils, rédiger les messages, c'est précisément ce que Stratvente fait avec toi.
            </p>

            <div className="mf-cta-audit">
              <div className="mf-cta-audit-title">🎯 Audit fidélisation offert, 30 minutes</div>
              <div className="mf-cta-audit-items">
                {[
                  'Analyse de ta base clients existante et de ton potentiel de revenus récurrents',
                  'Recommandation du système le plus adapté à ton activité et ton budget',
                  'Feuille de route concrète pour les 90 premiers jours',
                  'Sans engagement, on te donne de la valeur avant tout',
                ].map((item, i) => (
                  <div key={i} className="mf-cta-audit-item">
                    <div className="mf-cta-audit-check">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M2 5.2l2 2 4-4" stroke="#E4572E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="mf-cta-btns">
              <a
                href="mailto:commercial@stratvente.com?subject=Audit fidélisation - BrandStarter&body=Bonjour Dany, je souhaite bénéficier de l'audit fidélisation offert suite au parcours BrandStarter."
                className="mf-cta-btn"
              >
                Réserver mon audit gratuit
                <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
            </div>
            <div className="mf-cta-note">
              Dany Dassonville · Stratvente · commercial@stratvente.com
            </div>
          </div>

          <div className="mf-nav" style={{marginTop:24}}>
            <button className="mf-btn-secondary" onClick={() => { setPhase('diagnostic'); setDiagStep(0); setAnswers({}); }}>
              Refaire le diagnostic
            </button>
            <button className="mf-btn-primary" onClick={() => onValidate(`MODULE_FIDELISATION: Diagnostic complété, profil ${recommendation.titre}, système recommandé : ${recommendation.systeme}`)}>
              Valider et continuer →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
